module.exports = __webpack_public_path__ + "static/media/like.0d3e62f0.svg";